import { Children, isValidElement, type ReactNode } from 'react';
import { ANSWER_WIDGET_FENCE_LANG, parseAnswerWidgetMarker } from './answerWidgetPayload';

/**
 * The marker of an `openx-widget` fence, given the children react-markdown passes to `pre`, or null for any
 * other block. `id` is null when the fence does not name a valid widget id.
 */
export function widgetIdFromPre(children: ReactNode): { id: string | null } | null {
  const child = Children.toArray(children)[0];

  if (!isValidElement<{ className?: string; children?: ReactNode }>(child)) {
    return null;
  }

  const className = child.props.className ?? '';
  if (!className.split(/\s+/).includes(`language-${ANSWER_WIDGET_FENCE_LANG}`)) {
    return null;
  }

  const body = Children.toArray(child.props.children)
    .filter((node): node is string => typeof node === 'string')
    .join('');

  return { id: parseAnswerWidgetMarker(body) };
}
